/**
 * @generated SignedSource<<fc7d4bc55fc7b1b207a2ad6c9262a07b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateTeamName",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateTeamNameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateTeamNameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5aba9ac673195bf845334b3b89ba879a",
    "id": null,
    "metadata": {},
    "name": "UpdateTeamNameMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateTeamNameMutation(\n  $name: String!\n) {\n  updateTeamName(name: $name) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "7fc5489168d2189c99d57d3f7f33c83c";

export default node;
